module.exports = __webpack_public_path__ + "static/media/9.3841af62.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/9.mp3
// module id = 485
// module chunks = 0